import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaBath, FaToilet, FaUtensils } from "react-icons/fa";
import { Link } from "react-router-dom";
import usePublicProperties from "../hooks/usePublicProperties";

const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: false,
};

const renderMedia = (property, media, index) => {
  if (media.kind === "video") {
    return (
      <video
        src={media.url}
        muted
        playsInline
        controls
        className="property-media"
        aria-label={`${property.title} video ${index + 1}`}
      />
    );
  }

  return (
    <img
      src={media.url}
      alt={`${property.title} view ${index + 1}`}
      className="property-media"
    />
  );
};

const PropertyCard = () => {
  const { properties, loading, error } = usePublicProperties({ limit: 12 });

  if (loading) {
    return (
      <div className="min-h-screen bg-white py-10">
        <div className="container mx-auto px-4 text-center text-gray-600">
          Loading properties...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white py-10">
        <div className="container mx-auto px-4 text-center text-red-600">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white py-10">
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4">
        {properties.map((property) => (
          <div
            key={property.id}
            className="property-card bg-white shadow-sm rounded-lg overflow-hidden transform transition duration-300 hover:scale-105"
          >
            <Slider {...carouselSettings} className="property-media-slider">
              {property.media.map((media, index) => (
                <div key={`${media.id}-${index}`}>
                  <div className="property-media-frame">
                    <Link to={`/properties/${property.slug}`}>
                      {renderMedia(property, media, index)}
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
            <div className="property-card-body p-5">
              <Link to={`/properties/${property.slug}`}>
                <h2 className="property-card-title text-xl font-bold text-gray-800">
                  {property.title}
                </h2>
              </Link>
              <p className="property-card-desc text-gray-600 mt-3 text-sm leading-relaxed">
                {property.description}
              </p>
              <div className="property-card-meta flex flex-wrap justify-between items-center mt-4 text-gray-700">
                <div className="flex items-center space-x-1">
                  <FaBath className="text-secondary" />
                  <p className="text-sm">{property.bathrooms} Bathrooms</p>
                </div>
                <div className="flex items-center space-x-1">
                  <FaToilet className="text-secondary" />
                  <p className="text-sm">{property.toilets} Toilets</p>
                </div>
                <div className="flex items-center space-x-1">
                  <FaUtensils className="text-secondary" />
                  <p className="text-sm">{property.kitchens} Kitchen</p>
                </div>
              </div>
              <a
                href="https://wa.me/2348145765479"
                target="_blank"
                rel="noreferrer"
                className="property-card-cta mt-10 block w-full bg-primary text-white py-2 rounded-md text-center text-sm font-medium hover:bg-secondary transition"
              >
                Contact Agent
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyCard;
